export const ShowAccount = {
  mounted() {
    this.el.addEventListener("click", () => {
      // if the deal-details model is opened in from the clients page then
      // account-model is already visible in the background so close the
      // deal-details instead
      if (document.getElementById("account-modal-clients-page")) {
        this.pushEventTo(
          this.el.dataset.onHideTarget,
          this.el.dataset.onHide,
          {},
        )
      } else {
        this.pushEventTo(
          this.el.dataset.onShowTarget,
          this.el.dataset.onShow,
          {},
        )
      }
    })
  },
}
